/**
 * Light / Dark / System (Jeremy, 4 Nov 2026; punch list S13, Canopy F204).
 *
 * ONE setting per person, kept on the account by CANOPY and shared by both
 * applications and every computer. This app has no copy of its own: the API
 * reads and saves it through Canopy's /api/internal/theme (api/src/theme/).
 * Somebody who never chooses sees Light, and so does everybody while Canopy
 * cannot be reached.
 *
 * The same three values as Canopy's `shared/src/theme.ts`, duplicated on
 * purpose like the Deltek types (index.ts): the two apps talk over HTTP.
 */
export const THEME_CHOICES = ["light", "dark", "system"];
/** What a person who never chose sees, and what everybody sees while Canopy cannot be reached. */
export const DEFAULT_THEME = "light";
export function isThemeChoice(value) {
    return typeof value === "string" && THEME_CHOICES.includes(value);
}
/**
 * The key this browser remembers the last choice under, ONLY so the first paint is right
 * (web/index.html reads it before the app loads). The same name as Canopy's, in this
 * app's own origin. The account is the truth.
 */
export const THEME_STORAGE_KEY = "canopy.theme";
/** What the page shows for a choice: System follows the computer's setting. */
export function resolveTheme(choice, systemPrefersDark) {
    if (choice === "dark")
        return "dark";
    if (choice === "system")
        return systemPrefersDark ? "dark" : "light";
    return "light";
}
/** A remembered value, or Light for anything absent or unrecognised. */
export function parseStoredTheme(value) {
    return isThemeChoice(value) ? value : DEFAULT_THEME;
}
//# sourceMappingURL=theme.js.map